var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPsd = function SvgPsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50BEE8",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.787 14.21c0-.198.156-.415.408-.415H6.58c.78 0 1.482.523 1.482 1.524 0 .948-.702 1.475-1.482 1.475H5.579v.792c0 .265-.168.414-.384.414a.404.404 0 0 1-.408-.414zm.792.341v1.494H6.58c.402 0 .72-.354.72-.726 0-.42-.318-.768-.72-.768zM8.74 14.75c.138-1.164 1.894-1.373 2.722-.737.408.33-.024.851-.384.587-.444-.282-1.45-.414-1.577.21-.162.983 2.447.42 2.405 2.015-.042 1.523-2.249 1.559-3.077.875a.44.44 0 0 1-.084-.587c.156-.155.33-.21.534-.042.491.336 1.757.588 1.847-.265-.078-.887-2.573-.353-2.386-2.057M13.143 18c-.199 0-.415-.109-.415-.372v-3.406c0-.216.216-.372.415-.372h1.373c2.74 0 2.68 4.15.054 4.15zm.377-3.418v2.686h.996c1.619 0 1.691-2.687 0-2.687z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default SvgPsd;